/* eslint-disable no-unused-vars */
import moment from 'moment';
import React, { useMemo, useState } from 'react';
import { getTransferInstruction } from 'api/transfers/service';
import { useParams } from 'react-router';
import RecurringTransferWorkflow from './RecurringTransferWorkflow';
import RecurringFormProvider from './contexts/RecurringFormProvider';

const initialData = {
  frequencyType: 'WEEK'
};

export default function CreateRecurringTransfer() {
  return (
    <RecurringFormProvider initialData={initialData}>
      {() => <RecurringTransferWorkflow />}
    </RecurringFormProvider>
  );
}
